import React from 'react';
import ReactSelect from 'react-select';  // Rename this import to avoid conflict with Chakra UI Select
import '../styles/currencyselector.css';
import { useColorMode } from "@chakra-ui/react";

const TwoFAMethodSelector = ({ methods, preferences, handleToggleTwoFAMethod, isDisabled }) => {
    const { colorMode } = useColorMode();

    // Define a mapping for proper label formatting
    const methodLabels = {
        sms: "SMS",
        email: "Email"
    };

    // Format methods for react-select (value/label pair)
    const options = methods.map((method) => ({
        value: method,
        label: methodLabels[method] || method,  // Map to formatted label
    }));

    // Set the selected method (if already set in preferences)
    const selectedMethod = preferences.preferred_2fa_method
        ? { 
            value: preferences.preferred_2fa_method, 
            label: methodLabels[preferences.preferred_2fa_method] || preferences.preferred_2fa_method 
        }
        : null;

    // Handle selection change
    const handleChange = (selectedOption) => {
        if (selectedOption !== null) {
            handleToggleTwoFAMethod(selectedOption ? selectedOption.value : null);
        }
    };

    const customStyles = {
        input: (provided) => ({
            ...provided,
            color: '#717075',  // Input text color
        }),
    };

    const customStylesDark = {
        input: (provided) => ({
            ...provided,
            color: '#DFDFDF',  // Input text color
        }),
    };

    return (
        <ReactSelect
            value={selectedMethod}           // Controlled selected value
            onChange={handleChange}          // Handle method selection
            options={options}                // List of options
            isSearchable={false}             
            isDisabled={isDisabled}          
            styles={colorMode === 'light' ? customStyles : customStylesDark} 
            className={colorMode === 'light' ? "currency-selector" : "currency-selector-dark"}
            classNamePrefix="currency"
            menuPosition="fixed"
            menuPlacement="auto"
        />
    );
};

export default TwoFAMethodSelector;